<template>
  <div class="wrapper">
    <div class="titleSpan">
      <h2>
        <el-link
          icon="el-icon-arrow-left"
          @click="goTo('paperInterviewList')"
        ></el-link>
        面试详情 {{ tableData.interviewStatus }}
      </h2>
    </div>

    <div class="tableData">
      <div class="flex-table">
        <!-- <div class="flex-item" v-for="(item, index) in tableData" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="value">{{ item.value }}</div>
        </div> -->

        <div class="flex-item">
          <div class="title">论文名称</div>
          <div class="value">
            <el-button type="text" @click="pdfShow">{{
              tableData.paperName ? tableData.paperName + "(点击预览)" : ""
            }}</el-button>
          </div>
        </div>
        <div class="flex-item">
          <div class="title">考生姓名</div>
          <div class="value">{{ tableData.userName }}</div>
        </div>
        <div class="flex-item">
          <div class="title">论文分组</div>
          <div class="value">{{ tableData.paperGroupName }}</div>
        </div>
        <div class="flex-item">
          <div class="title">状态</div>
          <div class="value">{{ tableData.interviewStatus }}</div>
        </div>
        <div class="flex-item">
          <div class="title">答辩专家</div>
          <div class="value">{{ tableData.interviewTeacher }}</div>
        </div>
        <div class="flex-item">
          <div class="title">最终成绩</div>
          <div class="value">{{ tableData.score }}</div>
        </div>
        <div class="flex-item">
          <div class="title">附件</div>
          <div class="value">
            <el-button
              type="text"
              @click="download(tableData.replyUrl)"
              v-if="tableData.replyUrl"
              >{{ tableData.replyName }}</el-button
            >
          </div>
        </div>
        <div class="flex-item">
          <div class="title">面试时间</div>
          <div class="value">{{ tableData.interviewTime }}</div>
        </div>
      </div>
    </div>
    <div class="tableBox">
      <div class="tableBar darkBg">
        <div class="flex1 tableCell">评分标准</div>
        <div class="flex1 tableCell">重要性</div>
        <div class="flex1 tableCell">创新型</div>
        <div class="flex1 tableCell">客观性</div>
        <div class="flex1 tableCell">规范性</div>
        <div class="flex1 tableCell">应用性</div>
        <div class="flex1 tableCell">总分</div>
      </div>
      <div class="tableBar">
        <div class="flex1 tableCell">最高分</div>
        <div class="flex1 tableCell">18</div>
        <div class="flex1 tableCell">12</div>
        <div class="flex1 tableCell">12</div>
        <div class="flex1 tableCell">12</div>
        <div class="flex1 tableCell">6</div>
        <div class="flex1 tableCell">60</div>
      </div>
      <div class="tableBar fullBorder">
        <div class="flex1 tableCell">得分</div>
        <div class="flex1 tableCell">
          <el-input
            type="number"
            size="mini"
            @change="
              (e) => {
                interviewScore.importanceScore = e > 6 ? 6 : e < 0 ? 0 : e;
              }
            "
            v-model="interviewScore.importanceScore"
          ></el-input>
          <!-- {{ interviewScore.importanceScore }} -->
        </div>
        <div class="flex1 tableCell">
          <el-input
            type="number"
            size="mini"
            @change="
              (e) => {
                interviewScore.innovationScore = e > 6 ? 6 : e < 0 ? 0 : e;
              }
            "
            v-model="interviewScore.innovationScore"
          ></el-input>
          <!-- {{ interviewScore.innovationScore }} -->
        </div>
        <div class="flex1 tableCell">
          <el-input
            type="number"
            size="mini"
            @change="
              (e) => {
                interviewScore.objectivityScore = e > 6 ? 6 : e < 0 ? 0 : e;
              }
            "
            v-model="interviewScore.objectivityScore"
          ></el-input>
          <!-- {{ interviewScore.objectivityScore }} -->
        </div>
        <div class="flex1 tableCell">
          <el-input
            type="number"
            size="mini"
            @change="
              (e) => {
                interviewScore.normativeScore = e > 6 ? 6 : e < 0 ? 0 : e;
              }
            "
            v-model="interviewScore.normativeScore"
          ></el-input>
          <!-- {{ interviewScore.normativeScore }} -->
        </div>
        <div class="flex1 tableCell">
          <el-input
            type="number"
            size="mini"
            @change="
              (e) => {
                interviewScore.applicabilityScore = e > 6 ? 6 : e < 0 ? 0 : e;
              }
            "
            v-model="interviewScore.applicabilityScore"
          ></el-input>
          <!-- {{ interviewScore.applicabilityScore }} -->
        </div>
        <div class="flex1 tableCell">{{ interviewScore.score }}</div>
      </div>
    </div>
    <div style="margin: 20px 0; text-align: center">
      <el-button type="primary" @click="save"> 保存</el-button>
      <el-button type="primary" plain @click="$router.go(-1)">取消</el-button>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
  </div>
</template>


<script>
import { getPaperInterviewDetail, scoreInterview } from "@/api/paper.js";

import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

export default {
  data() {
    return {
      tableData: [
        { title: "论文名称", value: "" },
        { title: "考生姓名", value: "" },
        { title: "论文分组", value: "" },
        { title: "状态", value: "" },
        { title: "评分人", value: "" },
        { title: "最终成绩", value: "" },
        { title: "分数", value: "" },
        { title: "面试时间", value: "" },
      ],
      interviewScore: {
        importanceScore: 0,
        innovationScore: 0,
        objectivityScore: 0,
        normativeScore: 0,
        applicabilityScore: 0,
        id: this.$route.query.id,
        score: 0,
      },
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  created() {},
  mounted() {
    this.getPaperInterviewDetail();
  },
  components: { pdfPreview },
  methods: {
    download(url) {
      window.open(url, "_blank");
    },
    save() {
      scoreInterview(this.interviewScore).then((data) => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      });
    },
    pdfShow() {
      this.pdfData.pdfUrl = this.tableData.paperUrl;
      this.pdfData.pdfIfShow = true;
    },
    getPaperInterviewDetail() {
      let params = {
        id: this.$route.query.id,
      };
      getPaperInterviewDetail(params).then((data) => {
        console.log("data", data);
        // let infoData = this.tableData;
        // infoData[0].value = data.paperName;
        // infoData[1].value = data.userName;
        // infoData[2].value = data.paperGroupName;
        // infoData[3].value = data.interviewStatus;
        // infoData[4].value = data.interviewTeacher;
        // infoData[5].value = data.score;
        // infoData[6].value = data.interviewScore;
        // infoData[7].value = data.interviewTime;

        this.tableData = data;
        // data.id = this.$route.query.id;
        data.scoreDetailList[0].id = data.id;
        this.interviewScore = data.scoreDetailList[0];
      });
    },

    goTo(url) {
      this.$router.push({ name: url });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  font-size: 12px;
  margin: 15px;
  background: #fff;
  padding-bottom: 30px;

  .titleSpan {
    background: #fff;
    padding: 20px;
    margin-bottom: 5px;
  }

  .tableData {
    background: #fff;
    padding: 20px;
    min-height: 360px;
    .flex-table {
      margin: auto;
      .flex-item {
        display: flex;
        align-items: center;
        font-size: 16px;
        border: 1px solid #ccc;
        border-bottom-width: 0;
        &:last-child {
          border-bottom: 1px solid #ccc;
        }
        .title {
          display: flex;
          align-items: center;
          width: 160px;
          background-color: #f5f5f5;
          border-right: 1px solid #ccc;
          padding: 5px;
        }

        .value {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 10px;
          background-color: #fff;
          /deep/ .el-button {
            padding: 0;
          }
        }
      }
    }

    　　.infoTable {
      font-size: 12px;
      color: #71787e;
      border-collapse: collapse;
      text-align: center;
      padding-top: 20px;
    }

    　　.infoTable tr td {
      border: 1px solid #e6eaee;
      width: 200px;
      height: 35px;
      line-height: 35px;
      box-sizing: border-box;
      padding: 0 10px;
    }

    　　.infoTable tr td.column {
      background-color: #eff3f6;
      color: #393c3e;
    }
  }
}
.tableBar {
  width: 90%;
  display: flex;
  // min-width: 800px;
  margin: auto;
  font-size: 14px;
  border-right: 1px solid #999;
  .tableCell {
    border-top: 1px solid #999;
    border-left: 1px solid #999;
    padding: 6px 3px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.fullBorder {
  .tableCell {
    border-bottom: 1px solid #999;
    padding: 6px 3px;
  }
}
.flex1 {
  flex: 1;
}
</style>
